import React, { useState } from 'react';
import SPASelect from '../shared/SPASelect';
import compactSelectStyles from '../shared/compactSelectStyles';
import { UserOption } from './types';
import { useUserSearch } from './useAIPolicy';

interface IdentityOption {
  label: string;
  sublabel: string;
  value: string;
}

interface IdentityPickerProps {
  inputId: string;
  onSelect: (identity: string) => void;
  value: string;
}

// The identity is computed server-side — see AIIdentitySearch for why it cannot be built here.
const IdentityPicker = ({ inputId, onSelect, value }: IdentityPickerProps) => {
  const [term, setTerm] = useState('');
  const { data, isFetching } = useUserSearch(term);

  const options: IdentityOption[] = (data ?? []).map((u: UserOption) => ({
    label: `${u.name} · ${u.identity}`,
    sublabel: [u.email, u.subscriber].filter(Boolean).join(' · '),
    value: u.identity,
  }));

  return (
    <SPASelect
      isClearable
      formatOptionLabel={(option: IdentityOption) => (
        <div>
          <div className="tw-text-sm tw-text-spa-primary">{option.label}</div>
          {option.sublabel && <div className="tw-text-xs tw-text-spa-secondary">{option.sublabel}</div>}
        </div>
      )}
      inputId={inputId}
      inputValue={term}
      isLoading={isFetching}
      noOptionsMessage={() => (term.trim().length < 2 ? 'Type a name or email' : 'No matching users')}
      options={options}
      placeholder="Search by name or email"
      styles={compactSelectStyles}
      value={options.find(o => o.value === value) ?? null}
      onChange={option => onSelect((option as IdentityOption | null)?.value ?? '')}
      onInputChange={setTerm}
    />
  );
};

export default IdentityPicker;
